module.exports = __webpack_public_path__ + "static/components-1050a6dbd60283d57c922c64d1ddd47e.mp4";